<template>
	<div class="col-6">
		<div class="d-flex justify-content-between align-items-center">
			<h3 class="mb-0 font-20">Cards</h3>
			<button class="btn btn-secondary" @click="addCard">Add Card</button>
		</div>
		<table class="table" v-if="cards && cards.length > 0 && !loading">
			<thead>
				<tr>
					<th scope="col">Number</th>
					<th scope="col">Expiry date</th>
					<th scope="col" class="text-right mr-5">Status</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="card in cards" :key="card.id">
					<td>**** **** **** {{ card.last4 }}</td>
					<td>
						{{
							card.expMonth > 9
								? card.expMonth
								: "0" + card.expMonth
						}}/{{ card.expYear }}
					</td>
					<td class="text-right">
						<template v-if="card.defaultCard">
							<div class="text-success mr-5">
								<i class="fa-regular fa-circle-check"></i>
								Default
							</div>
						</template>
						<template v-if="!card.defaultCard">
							<button
								class="btn btn-secondary"
								@click="makeDefault(card.id)"
							>
								<span
									v-if="loadingDefault[card.id]"
									class="spinner-border spinner-border-sm"
									role="status"
									aria-hidden="true"
								></span>
								Make default
							</button>
						</template>
					</td>
				</tr>
			</tbody>
		</table>
		<Spinner v-if="loading" />
		<ErrorAlert :error="errMsg" v-if="errMsg && !loading" />
		<ErrorDialog ref="errDialog" />
		<CardAddDialog ref="cardAddDialog" @cardadded="getCards" />
	</div>
</template>

<script>
import Spinner from "../shared/Spinner";
import ErrorAlert from "../shared/ErrorAlert";
import ErrorDialog from "../shared/ErrorDialog";
import CardService from "../../services/card";
import CardAddDialog from "./CardAddDialog";

export default {
	name: "CardList",
	components: {
		Spinner,
		ErrorAlert,
		ErrorDialog,
		CardAddDialog,
	},
	data() {
		return {
			loading: false,
			errMsg: null,
			cards: [],
			loadingDefault: {},
		};
	},
	mounted() {
		this.getCards();
	},
	methods: {
		getCards() {
			this.loading = true;
			CardService.instance()
				.getCardsList()
				.then((res) => {
					this.cards = res.data;
					this.loading = false;
					this.errMsg = null;
				})
				.catch((err) => {
					this.errMsg = err;
					this.loading = false;
				});
		},
		addCard() {
			this.$refs.cardAddDialog.show();
		},
		makeDefault(id) {
			this.$set(this.loadingDefault, id, true);
			CardService.instance()
				.makeDefaultCard(id)
				.then(() => {
					this.loadingDefault[id] = false;
					this.getCards();
				})
				.catch((err) => {
					this.loadingDefault[id] = false;
					this.$refs.errDialog.show(err);
				});
		},
	},
};
</script>

<style scoped>
.min-height {
	min-height: 250px;
	position: relative;
}
</style>